import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const PasswordReset = withLazyFallback(() => import('components/Auth'));
const PasswordRequest = withLazyFallback(() => import('components/Auth/request'));
const PasswordSet = withLazyFallback(() => import('components/Auth/set'));
const Login = withLazyFallback(() => import('components/admin/components/Login/Login'));
const NotFound = withLazyFallback(() => import('components/NotFound'));
const AdminPasswordReset = withLazyFallback(() => import('components/admin/pages/ResetPassword'));
const AdminPasswordRequest = withLazyFallback(
  () => import('components/admin/pages/ResetPassword/request')
);
const AdminPasswordSet = withLazyFallback(() => import('components/admin/pages/ResetPassword/set'));
const Logout = withLazyFallback(() => import('components/shared/Logout/Logout'));

const AUTHENTICATION = [
  {
    path: 'admin/login',
    element: <Login />
  },
  {
    path: 'password/*',
    element: <PasswordReset />,
    children: [
      { path: 'request', element: <PasswordRequest /> },
      { path: 'reset/:token', element: <PasswordSet /> },
      { path: '*', element: <NotFound portal="password/request" /> }
    ]
  },
  {
    path: 'admin/password/*',
    element: <AdminPasswordReset />,
    children: [
      { path: 'request', element: <AdminPasswordRequest /> },
      { path: 'reset/:token', element: <AdminPasswordSet /> },
      { path: '*', element: <NotFound portal="admin" /> }
    ]
  },
  {
    path: 'login',
    element: <Login loginType="user" />
  },
  {
    path: 'logout',
    element: <Logout />
  }
];

export default AUTHENTICATION;
